import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, MaskedLines, Reveal } from "../motion/Reveal";
import { BrendanConsole } from "../brendan/BrendanConsole";

export const BrendanTeaser = () => (
  <section id="brendan" data-testid="brendan-section" className="relative overflow-hidden bg-[#0C0A09] py-24 text-stone-100 sm:py-32">
    <div className="absolute right-0 top-0 h-[600px] w-[600px] rounded-full bg-orange-700/15 blur-[160px]" />
    <div className="relative mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow>06 — In development</Eyebrow>
          <h2 className="mt-8 font-display text-4xl font-medium leading-[1] tracking-tight sm:text-6xl lg:text-7xl">
            <MaskedLines inView lines={["Brendan —", <span key="r" className="tc-copper-text">Round-the-Clock</span>, "Intelligence."]} />
          </h2>
        </div>
        <Reveal className="lg:col-span-5">
          <p className="text-base leading-relaxed text-stone-300 sm:text-lg">
            Brendan is a proprietary intelligent-monitoring product we are developing. The concept: AI-assisted detection of
            security events, verified by people, with clear notifications and structured response workflows.
          </p>
          <Link to="/brendan" data-testid="brendan-learn-more"
            className="tc-link mt-6 inline-flex items-center gap-2 text-sm font-semibold text-orange-400">
            Explore the concept <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
      <Reveal className="mt-14"><BrendanConsole /></Reveal>
    </div>
  </section>
);
